/**
 * Returns the appropriate help desk URL based on user role
 */
export const getHelpDeskUrl = (role: string): string => {
  // SaaS Users
  if (role.includes("SAAS") || role === "Freemium" || role === "Open Link") {
    return "https://fohr-brand-user-help-center.helpscoutdocs.com/";
  }

  // Managed Service Users
  if (role.includes("Managed Services") || role === "Brand Owner") {
    return "https://fohr-managed-campaign-help-center.helpscoutdocs.com/";
  }

  // Influencer Users
  if (["Influencer", "Influencer Rep"].includes(role)) {
    return "https://fohr-influencer-help-center.helpscoutdocs.com/";
  }

  // Fohr Users (default)
  return "https://fohr-user-help-center.helpscoutdocs.com/";
};
